var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapActions } from "vuex";
import { Component } from 'vue-property-decorator';
import ReportStockService from "../../api/ReportStockService";
import GlobalVue from "../../globalVue";
import DetailList from "./DetailList.vue";
import QueryList from './QueryList';
var QueryDetailList = (function (_super) {
    __extends(QueryDetailList, _super);
    function QueryDetailList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '1';
        _this.showTabMenuPower = false;
        _this.TabMenuPowerId = 133;
        _this.TabMenuPowerAuthCode = '210001';
        _this.depot_ids = [];
        _this.goods_code = '';
        _this.goods_format_id = 0;
        _this.keyword = '';
        return _this;
    }
    QueryDetailList.prototype.created = function () {
        var _this = this;
        this.service = ReportStockService.getInstance();
        this.getAuth(this.TabMenuPowerAuthCode).then(function (pageAuth) {
            _this.TabMenuPowerPageAuth = pageAuth;
            _this.showTabMenuPower = !!pageAuth;
        });
    };
    QueryDetailList.prototype.mounted = function () {
    };
    QueryDetailList.prototype.tabBeforeLeave = function (tab, event) {
        if (tab == 0) {
            var pageAuth = this.TabMenuPowerPageAuth;
            GlobalVue.$emit('addTab', {
                component: QueryList,
                title: '库存查询',
                showExist: true,
                name: this.TabMenuPowerId,
                cprops: __assign({}, pageAuth.Response, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
            });
            return false;
        }
    };
    QueryDetailList = __decorate([
        Component({
            components: {
                'stock-detail-list': DetailList,
            },
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], QueryDetailList);
    return QueryDetailList;
}(Vue));
export default QueryDetailList;
